(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["np-ruleta-productos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('np-product-roulette')) {
    class NPProductRoulette extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.indicators = Array.from(this.querySelectorAll('[data-slide-to]'));
        this.products = Array.from(this.querySelectorAll('[data-product]'));
        this.productByIndex = new Map(this.products.map((product) => [Number(product.dataset.productIndex), product]));
        this.activeIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.menuSection = document.querySelector('.shopify-section-group-header-group.header-section');
        this.announcementSurface = document.querySelector('.shopify-section-group-header-group .announcements_and_icons');
        this.announcementTextSurfaces = this.announcementSurface
          ? Array.from(this.announcementSurface.querySelectorAll('.announcement_block, .announcement_wrapper, .announcement_item, .announcement_text, .announcement_icon, .announcement-social-icons, .announcement-social-icons a, .announcement-social-icons svg'))
          : [];
        const headerSurfaces = this.menuSection
          ? [this.menuSection, this.menuSection.querySelector('header.site-header')]
          : [];
        this.menuSurfaces = Array.from(new Set([...headerSurfaces, this.announcementSurface].filter(Boolean)));
        const styleSurfaces = Array.from(new Set([...this.menuSurfaces, ...this.announcementTextSurfaces]));
        this.originalMenuSurfaceStyles = styleSurfaces.map((surface) => ({
          surface,
          backgroundColor: surface.style.backgroundColor,
          transition: surface.style.transition,
          color: surface.style.color,
        }));
        this.interval = Number(this.dataset.interval) || 5000;
        this.autoplay = this.dataset.autoplay === 'true';
        this.pointerPaused = false;
        this.focusPaused = false;
        this.skipProductClick = false;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.applyMenuTint(this.slides[this.activeIndex]);
        this.onClick = this.handleClick.bind(this);
        this.onControlsPointerDown = this.handleControlsPointerDown.bind(this);
        this.onPointerEnter = this.handlePointerEnter.bind(this);
        this.onPointerLeave = this.handlePointerLeave.bind(this);
        this.onFocusIn = this.handleFocusIn.bind(this);
        this.onFocusOut = this.handleFocusOut.bind(this);
        this.onVisibilityChange = this.handleVisibilityChange.bind(this);
        this.onMotionChange = this.handleMotionChange.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('pointerdown', this.onControlsPointerDown);
        this.addEventListener('pointerenter', this.onPointerEnter);
        this.addEventListener('pointerleave', this.onPointerLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        if (this.motionPreference.addEventListener) {
          this.motionPreference.addEventListener('change', this.onMotionChange);
        } else if (this.motionPreference.addListener) {
          this.motionPreference.addListener(this.onMotionChange);
        }
        this.readyTimer = window.setTimeout(() => this.classList.add('is-ready'), 1200);
        this.startAutoplay();
      }

      getMotionDuration() {
        const value = window.getComputedStyle(this).getPropertyValue('--np-ruleta-motion-duration').trim();
        const duration = Number.parseFloat(value);
        if (!Number.isFinite(duration)) return 1100;
        if (value.endsWith('ms')) return duration;
        if (value.endsWith('s')) return duration * 1000;
        return duration;
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.originalMenuSurfaceStyles.forEach(({ surface, backgroundColor, transition, color }) => {
          surface.style.backgroundColor = backgroundColor;
          surface.style.transition = transition;
          surface.style.color = color;
        });
        window.clearTimeout(this.readyTimer);
        window.clearTimeout(this.transitionTimer);
        window.clearTimeout(this.controlsVisibilityTimer);
        window.clearTimeout(this.skipProductClickTimer);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('pointerdown', this.onControlsPointerDown);
        this.removeEventListener('pointerenter', this.onPointerEnter);
        this.removeEventListener('pointerleave', this.onPointerLeave);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        if (this.motionPreference && this.motionPreference.removeEventListener) {
          this.motionPreference.removeEventListener('change', this.onMotionChange);
        } else if (this.motionPreference && this.motionPreference.removeListener) {
          this.motionPreference.removeListener(this.onMotionChange);
        }
      }

      handleClick(event) {
        const productLink = event.target.closest('.np-ruleta__click-target');
        if (this.skipProductClick) {
          this.skipProductClick = false;
          window.clearTimeout(this.skipProductClickTimer);
          this.skipProductClickTimer = null;
          if (productLink) {
            event.preventDefault();
            return;
          }
        }

        const control = event.target.closest('[data-slide-step], [data-slide-to]');
        if (!control || !this.contains(control)) return;
        if (control.hasAttribute('data-slide-step')) {
          const step = Number(control.dataset.slideStep) || 1;
          this.showSlide(this.activeIndex + step, step);
          return;
        }
        const targetIndex = Number(control.dataset.slideTo);
        const direction = targetIndex >= this.activeIndex ? 1 : -1;
        this.showSlide(targetIndex, direction);
      }

      handleControlsPointerDown(event) {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;

        const controlsWereHidden = !this.classList.contains('is-controls-visible');
        if (controlsWereHidden && event.target.closest('.np-ruleta__click-target')) {
          this.skipProductClick = true;
          window.clearTimeout(this.skipProductClickTimer);
          this.skipProductClickTimer = window.setTimeout(() => {
            this.skipProductClick = false;
            this.skipProductClickTimer = null;
          }, 800);
        }

        this.classList.add('is-controls-visible');
        window.clearTimeout(this.controlsVisibilityTimer);
        this.controlsVisibilityTimer = window.setTimeout(() => {
          this.classList.remove('is-controls-visible');
          this.controlsVisibilityTimer = null;
        }, 3200);
      }

      handlePointerEnter(event) {
        if (event.pointerType !== 'mouse') return;
        this.pointerPaused = true;
        this.stopAutoplay();
      }

      handlePointerLeave(event) {
        if (event.pointerType !== 'mouse') return;
        this.pointerPaused = false;
        this.startAutoplay();
      }

      handleFocusIn() {
        this.focusPaused = true;
        this.stopAutoplay();
      }

      handleFocusOut(event) {
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        this.focusPaused = false;
        this.startAutoplay();
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.stopAutoplay();
          return;
        }
        this.startAutoplay();
      }

      handleMotionChange() {
        if (this.motionPreference.matches) {
          this.stopAutoplay();
          return;
        }
        this.startAutoplay();
      }

      startAutoplay() {
        this.stopAutoplay();
        if (
          !this.autoplay ||
          this.slides.length < 2 ||
          this.motionPreference.matches ||
          this.pointerPaused ||
          this.focusPaused ||
          document.hidden
        ) return;
        this.timer = window.setInterval(() => this.showSlide(this.activeIndex + 1, 1), this.interval);
      }

      stopAutoplay() {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      applyMenuTint(slide) {
        const color = slide && slide.dataset.menuColor;
        if (!this.menuSurfaces.length || !color) return;
        const duration = this.getMotionDuration();
        const transition = this.motionPreference.matches ? 'none' : `background-color ${duration}ms ease`;
        this.menuSurfaces.forEach((surface) => {
          surface.style.transition = transition;
          surface.style.backgroundColor = color;
        });
        this.announcementTextSurfaces.forEach((surface) => {
          surface.style.color = '#315c37';
        });
      }

      showSlide(targetIndex, direction) {
        if (this.slides.length < 2) return;
        const total = this.slides.length;
        const nextIndex = ((targetIndex % total) + total) % total;
        if (nextIndex === this.activeIndex) return;
        window.clearTimeout(this.transitionTimer);
        this.slides.forEach((slide) => {
          slide.classList.remove('is-entering-next', 'is-entering-previous', 'is-leaving-next', 'is-leaving-previous');
        });
        this.products.forEach((product) => {
          product.classList.remove('is-entering-next', 'is-entering-previous', 'is-leaving-next', 'is-leaving-previous');
        });
        const currentSlide = this.slides[this.activeIndex];
        const nextSlide = this.slides[nextIndex];
        const movement = direction < 0 ? 'previous' : 'next';
        const currentProduct = this.productByIndex.get(this.activeIndex);
        const nextProduct = this.productByIndex.get(nextIndex);
        const transitionDuration = this.getMotionDuration();
        if (currentProduct) {
          currentProduct.classList.remove('is-active');
          currentProduct.classList.add('is-leaving-' + movement);
        }
        if (nextProduct) nextProduct.classList.add('is-entering-' + movement);
        currentSlide.classList.remove('is-active');
        currentSlide.classList.add('is-leaving-' + movement);
        currentSlide.setAttribute('aria-hidden', 'true');
        currentSlide.inert = true;
        nextSlide.classList.add('is-entering-' + movement);
        nextSlide.setAttribute('aria-hidden', 'false');
        nextSlide.inert = false;
        this.applyMenuTint(nextSlide);
        void nextSlide.offsetWidth;
        nextSlide.classList.add('is-active');
        this.indicators.forEach((indicator, index) => {
          if (index === nextIndex) {
            indicator.setAttribute('aria-current', 'true');
          } else {
            indicator.removeAttribute('aria-current');
          }
        });
        this.activeIndex = nextIndex;
        this.startAutoplay();
        this.transitionTimer = window.setTimeout(() => {
          currentSlide.classList.remove('is-leaving-next', 'is-leaving-previous');
          nextSlide.classList.remove('is-entering-next', 'is-entering-previous');
          if (currentProduct) currentProduct.classList.remove('is-leaving-next', 'is-leaving-previous');
          if (nextProduct) {
            nextProduct.classList.remove('is-entering-next', 'is-entering-previous');
            nextProduct.classList.add('is-active');
          }
          this.transitionTimer = null;
        }, transitionDuration + 40);
      }
    }

    customElements.define('np-product-roulette', NPProductRoulette);
  }

  } catch(e) { console.error(e); }
})();
})();
